var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddAPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12c0 .825.675 1.5 1.5 1.5s1.5-.675 1.5-1.5V9h3c.825 0 1.5-.675 1.5-1.5S11.325 6 10.5 6h-3V3c0-.825-.675-1.5-1.5-1.5S4.5 2.175 4.5 3v3h-3C.675 6 0 6.675 0 7.5S.675 9 1.5 9h3v3z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 21,
    r: 4.5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.745 9H31.5c1.65 0 3 1.35 3 3v18c0 1.65-1.35 3-3 3h-24c-1.65 0-3-1.35-3-3V14.58c.45.255.945.42 1.5.42 1.65 0 3-1.35 3-3v-1.5h1.5c1.65 0 3-1.35 3-3 0-.555-.165-1.05-.42-1.5h9.6c.84 0 1.65.36 2.205.975L26.745 9zM12 21c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddAPhoto);
export default __webpack_public_path__ + "static/media/ic_add_a_photo.dd305c8c6cd1aae6cfe4786a84ab2b07.svg";
export { ForwardRef as ReactComponent };